// shared/page-skill-entries.ts — window.SKILL_CATALOG (ft_boot_inc.php build_js_skill_catalog) as the {item_id, variable_name} registry
// createSkillRequirementChecker() expects. The catalog is keyed BY skill item_id and its rows carry no item_id of their own, so a bare
// Object.values() hands the checker id-less rows and every requires_skill_tier_N gate reads as unmet (2026-10-14).
export type PageSkillEntry = { item_id: string; variable_name: string };

let memo: PageSkillEntry[] | null = null;
/** [] off ft_boot pages (no SKILL_CATALOG) and outside a browser (Node tests): callers treat an empty registry as "cannot judge a skill gate". */
export function pageSkillEntries(): PageSkillEntry[] {
    if (memo?.length) return memo;
    if (typeof window === 'undefined') return [];
    const catalog = (window as unknown as { SKILL_CATALOG?: Record<string, { variable_name?: unknown } | null> }).SKILL_CATALOG ?? {};
    memo = Object.entries(catalog).flatMap(([item_id, row]) =>
        typeof row?.variable_name === 'string' && row.variable_name !== '' ? [{ item_id, variable_name: row.variable_name }] : []);
    return memo;
}
